import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import update from './update'

export default function* advanceToSummary(apis) {
  const state = yield effects.select()

  const success = yield effects.call(
    update,
    apis,
    state.signupEdit.get('edit'),
    state.signupEdit.get('meta'),
  )
  if (!success) {
    return
  }

  yield effects.put.resolve(pushPath('/summary'))

  yield effects.call(() => document.getElementById('wrapper').scrollIntoView())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/advanceToSummary.js